import breadcrumbImage from "../../assets/images/course/cousre.jpg";
import axios from "axios";
import { useState, useEffect } from "react";
import { Col, Container, Row, Button, Modal } from "react-bootstrap";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";

const Terms = () => {
  const [cmsData, setCmsData] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [activeVersion, setActiveVersion] = useState(null);
  const [showModal, setShowModal] = useState(false);
const [bgImage, setBgImage] = useState("");
  useEffect(() => {
    fetchCMSData();
       bannerimg()
  }, []);
   const bannerimg = async () => {
            try {
              const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
              );
        
              const baseUrl = res.data.imagePath;
              const courseImage = res.data.home_setting[0]?.course_image;
        
              // Full image URL
              const fullUrl = baseUrl + courseImage;
        
              setBgImage(fullUrl);
            } catch (error) {
              console.error("Error fetching banner:", error);
            }
          };
  const fetchCMSData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/terms-conditions-list`
      );
      const data = res.data.data || [];
      setCmsData(data);
      setImagePath(res.data.imagePath);

      if (data.length > 0) setActiveVersion(data[0]);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };

  const handleVersionClick = (version) => {
    setActiveVersion(version);
    setShowModal(false);
  };

  return (
    <>
     <div className="page_header"></div>
      {activeVersion && (
        <section className="Terms course about_section">
          {/* Breadcrumb */}
          <div className="rs-breadcrumbs breadcrumbs-overlay">
            <div className="breadcrumbs-img">
            <img src={bgImage} alt="Breadcrumbs bg" />
            </div>
            <div className="breadcrumbs-text white-color">
              <h1 className="page-title">Terms & Conditions</h1>
            </div>
          </div>

          <Container>
            <section className="py-60">
              <Row>
                <Col lg={12}>
                  {/* Active Version Details */}
                  <div className="sec-title">
                    <div className="d-flex justify-content-between align-items-center mb-3 align-items-center flex-wrap">
                      <div className="mb-3 versions">
                        <p className="mb-1">
                          <strong>Version:</strong>
                          <span className="d-block">
                            {activeVersion.version}
                          </span>
                        </p>
                        <p className="mb-1">
                          <strong>Effective Date:</strong>{" "}
                          <span className="d-block">{activeVersion.date}</span>
                        </p>

                        <p>
                          <strong> Changes Summary</strong>
                          <span className="d-block">{activeVersion.title}</span>
                        </p>
                      </div>
                      <button
                        className="educate-btn sm"
                        onClick={() => setShowModal(true)}
                      >
                        <span className="educate-btn__curve" />
                        Previous Versions
                      </button>
                    </div>

                    {/* Description */}
                    <div
                      className="terms_content"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          activeVersion.description || ""
                        ),
                      }}
                    ></div>

                    {/* Policy Image */}
                    {activeVersion.image && (
                      <div className="term_img text-center mt-3">
                        <img
                          src={`${imagePath}${activeVersion.image.replace(
                            /\\/g,
                            "/"
                          )}`}
                          alt={activeVersion.title}
                          className="img-fluid rounded shadow-sm"
                        />
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </section>
          </Container>

          {/* Modal for Previous Versions */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Previous versions</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="text-muted small mb-3">
                Below is a summary of previous versions of the Terms & Conditions
                for your review.
              </p>
              {cmsData
                .slice() // copy
                .reverse() // latest पहले
                .map((policy) => (
                  <div
                    key={policy.id}
                    className="mb-3 border-bottom d-flex align-items-center gap-3 pb-2"
                  >
                    <p>
                      <strong>
                        {new Date(policy.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "long",
                          year: "numeric",
                        })}
                      </strong>
                    </p>
                    <Link
                      className="d-flex align-items-center gap-2 color-primary"
                      onClick={() => handleVersionClick(policy)}
                    >
                      View this version <FaExternalLinkAlt className="" />
                    </Link>
                  </div>
                ))}
            </Modal.Body>
          </Modal>
        </section>
      )}
    </>
  );
};

export default Terms;
